export default "__VITE_ASSET__Dgp05aEe__"